import * as types from '@/store/mutationTypes';
import { initialState } from '@/store/initialState';
import { NotificationsTypes } from '@/constants/notificationsTypes';
import shoppingCartService from '@/http/services/shoppingCartService';

export const actions = {
    getShoppingCart: async ({ commit, dispatch }, payload) => {
        const shoppingCart = await shoppingCartService.getShoppingCart(payload);
        
        if (shoppingCart.error) {
            dispatch('createNotification', {
                message: `${shoppingCart.error}`,
                type: NotificationsTypes.WARNING
            });
        }

        commit(types.SET_SHOPPING_CART, shoppingCart);
        commit(types.SET_SHOPPING_INDICATOR, shoppingCart && shoppingCart.rosters && !!shoppingCart.rosters.length);
    },

    removeRosterFromCart: async ({ dispatch }, payload) => {
        await shoppingCartService.removeActivityRosterFromCart(payload);

        await dispatch('getShoppingCart', {
            parentId: payload.parentId,
            options: { couponCode: payload.couponCode }
        })
    },

    removeRosterAftercareDayFromCart: async ({ dispatch }, payload) => {
        await shoppingCartService.removeRosterAftercareDayFromCart(payload);

        await dispatch('getShoppingCart', {
            parentId: payload.parentId,
            options: { couponCode: payload.couponCode }
        })
    },

    removeDateFromRosterInCart: async ({ dispatch }, payload) => {
        await shoppingCartService.removeDateFromRosterInCart(payload);

        await dispatch('getShoppingCart', {
            parentId: payload.parentId,
            options: { couponCode: payload.couponCode }
        })
    },

    removeAddonFromRosterInCart: async ({ dispatch }, payload) => {
        await shoppingCartService.removeAddonFromActivityRosterInCart(payload);

        await dispatch('getShoppingCart', {
            parentId: payload.parentId,
            options: { couponCode: payload.couponCode }
        })
    },

    getExistCardInfo: async ({ commit }, payload) => {
        const existCard = await shoppingCartService.getExistCardInfo(payload);

        commit(types.SET_EXIST_CARD, existCard);
    },

    createBillingInfo: async ({ dispatch, commit, getters }, payload) => { 
        const { cardNumber, cardExpiry, cardCvc, parentId, stripe } = payload;

        try {
            const stripeResponse = await shoppingCartService.createStripeTokenForCard({ 
                cardNumber,
                cardExpiry,
                cardCvc,
                stripe });

            await shoppingCartService.createBillingInfo({
                options: {
                    sourceToken: stripeResponse.token.id
                },
                parentId
            });

            await shoppingCartService.paymentInfo({ options: { parentId }, couponCode: getters.couponCode });

            commit(types.SET_SHOPPING_CART, initialState.shoppingCart.shoppingCart);
            commit(types.SET_PAYMENT, true);
            commit(types.SET_SHOPPING_INDICATOR, false);
            commit(types.SET_COUPON_CODE, null);
            commit(types.TOGGLE_FREE_ACTIVITY, false);
        } catch (e) {
            if (e.type) {
                dispatch('createNotification', {
                    message: 'Your Billing Details was rejected by Stripe',
                    type: NotificationsTypes.ERROR
                });
            }
        }
    },

    createBillingInfoWithExistedCard: async ({ dispatch, commit, getters }, payload) => {
        try {
            await shoppingCartService.paymentInfo({ options: payload, couponCode: getters.couponCode });

            commit(types.SET_SHOPPING_CART, initialState.shoppingCart.shoppingCart);
            commit(types.SET_PAYMENT, true);
            commit(types.SET_SHOPPING_INDICATOR, false);
            commit(types.SET_COUPON_CODE, null);
            commit(types.TOGGLE_FREE_ACTIVITY, false);
        } catch (e) {
            if (e.type) {
                dispatch('createNotification', {
                    message: 'Your Billing Details was rejected by Stripe',
                    type: NotificationsTypes.ERROR
                });
            }
        }
    },

    createBillingInfoForFree: async ({ commit, getters, dispatch }, payload) => {
        await shoppingCartService.paymentInfo({ options: payload, couponCode: getters.couponCode });

        commit(types.SET_SHOPPING_CART, initialState.shoppingCart.shoppingCart);
        commit(types.SET_PAYMENT, true);
        commit(types.SET_SHOPPING_INDICATOR, false);
        commit(types.SET_COUPON_CODE, null);
        commit(types.TOGGLE_FREE_ACTIVITY, true);
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/shoppingCart/actions.js